import './index.css';

export default function Loader({ visible }) {
  return <>
    {visible ? <><br /><span className="loader"></span></> : <></>}
  </>
}